/* eslint-disable global-require */
import useJwt from '@/auth/jwt/useJwt'

const axios = require('axios')

async function getStores(accessToken) {
  const storesList = await axios.get('https://app.manyconvert.com/api/stores', {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  }).then(resp => resp.data)
  return storesList
}

export async function getStoresUserActived(accessToken) {
  const storesList = await axios.get('https://app.manyconvert.com/api/stores/list/activated', {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  }).then(resp => resp.data)
  return storesList
}

export async function createStore(accessToken, data) {
  const storesList = await axios.post('https://app.manyconvert.com/api/stores',
    data,
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }).then(resp => resp.data)
  return storesList
}

export default async function stores() {
  const userData = JSON.parse(localStorage.getItem('userData'))
  const storesList = (userData.role === 'admin' || userData.id === 624) ? await getStores(userData.mc_access_token) : userData.attending_stores
  return storesList
}
